import $ from 'jquery';

// NOTE: This is not perfect because it may run before the font is loaded, which
//       leads to slightly different sizes. However, it is generally close
//       enough (the currently selected item is in view) and avoids the vertical
//       scrolling associated with `.scrollIntoView({ inline: center })`.

function scrollToSelected(scrollableNavSelector, selectedItemSelector) {
  const $nav = $(scrollableNavSelector);
  const $selected = $(selectedItemSelector, $nav);

  if (!$nav?.get(0) || !$selected?.get(0)) {
    return;
  }

  const selectedLeft = $selected[0].offsetLeft;
  const selectedWidth = $selected[0].offsetWidth;
  const parentWidth = $nav[0].offsetWidth;
  const desiredLeft = (parentWidth - selectedWidth) / 2;

  $nav[0].scrollLeft = selectedLeft - desiredLeft;
}

scrollToSelected('.masthead__nav', 'li.selected');
scrollToSelected('.sub-nav', 'li.selected');
